import CalculatorSection from "./calculator/CalculatorSection"
import LightFooter from "./footer/LightFooter"
import LightHeader from "./header/LightHeader"
import HeroSection from "./hero/HeroSection"
import LiveProofSection from "./liveProof/LiveProofSection"
import FieldResultsSection from "./fieldResults/FieldResultsSection"
import QuoteSection from "./fieldResults/QuoteSection"
import ForgeProofSection from "./forgeProof/ForgeProofSection"
import LeadInterceptionSection from "./leadInterception/LeadInterceptionSection"
import NotForSection from "./notFor/NotForSection"
import OriginSection from "./origin/OriginSection"
import OmnichannelSection from "./omnichannel/OmnichannelSection"
import SafetyNetSection from "./safetyNet/SafetyNetSection"
import SetupSection from "./setup/SetupSection"
import SundayGapSection from "./sundayGap/SundayGapSection"
import TestDriveSection from "./testDrive/TestDriveSection"
import { contentColumnClass, pageRootClass } from "./lightTheme"

export default function RoofingLightLanding() {
  return (
    <div className="roofing-light-canvas min-h-screen w-full bg-[#FAFAFA]">
      <LightHeader />
      <div className={`${pageRootClass} pt-0`}>
        <div className={contentColumnClass}>
          <HeroSection />
          <CalculatorSection />
          <OriginSection />
          <FieldResultsSection />
          <QuoteSection />
          <TestDriveSection />
          <SundayGapSection />
          <LiveProofSection />
          <SetupSection />
          <OmnichannelSection />
          <SafetyNetSection />
          <NotForSection />
          <LeadInterceptionSection />
          <ForgeProofSection />
        </div>
        <LightFooter />
      </div>
    </div>
  )
}
